import { useEffect, useState } from 'react';
import dashboardCircle from '@assets/icons/dashboard-circle.png';
import arrowCircleDown from '@assets/icons/arrowCircleDown.svg';
import arrowCircleUP from '@assets/icons/arrowCircleUp.svg';
import flowline from '@assets/icons/flowline.svg';
import { Spin, Empty, Tooltip } from 'antd';
import ScrollContainer from 'react-indiana-drag-scroll';

const COLUMNS = [
  { isBtn: true, label: 'Group' },
  {
    label: 'Project Value',
    subLabel: '(in Rs Cr)',
    tooltip: 'Project contract value (Rs. Cr.)',
    colored: false,
  },
  {
    label: 'POCM',
    subLabel: '(%)',
    tooltip: 'POCM data available at the project level only',
    colored: true,
  },
  // {
  //   label: 'Projects',
  //   subLabel: '(Using BBS optimization tool)',
  //   tooltip: 'Total no. of projects that have adopted the tool',
  //   colored: false,
  // },
  // {
  //   label: 'Active Projects',
  //   tooltip: 'Total no. of projects that have complete wastage information',
  //   colored: true,
  // },

  {
    label: 'Quantity Processed',
    subLabel: '(in MT)',
    tooltip: 'Reinforcement quantity processed in MT',
    colored: false,
  },
  // {
  //   label: 'Weighted average of quantity',
  //   tooltip: 'Total no. of projects that have complete wastage information',
  //   colored: true,
  // },
  {
    label: 'Wastage',
    subLabel: '(in %)',
    tooltip: 'BBS system generated',
    colored: false,
  },
  {
    label: 'Budgeted Wastage',
    subLabel: '(in %)',
    tooltip: 'From CB/CTC',
    colored: false,
  },
  {
    label: 'Savings wrt budgeted wastage',
    subLabel: '(in %)',
    tooltip: 'Difference of Budgeted wastage & Actual wastage',
    colored: false,
  },
  {
    label: 'Savings wrt budgeted wastage',
    subLabel: '(in MT)',
    tooltip: 'Quantity savings in MT',
    colored: true,
  },
  {
    label: 'Savings value',
    subLabel: '(in Rs Lakhs)',
    tooltip: '@ steel rates of INR 55,000 per MT',
    colored: true,
  },
];

export default function WastageProjectInfoMonthly({ dataSource, loading }) {
  const [expandedRows, setExpandedRows] = useState(new Set());

  const getTransformProjectsData = (
    data = [],
    prefix = '',
    level = 1,
    parentId = '',
  ) => {
    return data.map((item, index) => {
      const id = parentId ? `${parentId}-${index + 1}` : `${index + 1}`;
      // const name = `${prefix}${data.length > 1 ? `-${index + 1}` : ''}`;
      const name = item.name || item.code;

      const mappedItem = {
        id,
        name,
        project_value: item.project_value || null,
        pocm: item.pocm,
        active_projects: item.active_projects,
        project_count: item.project_count || null,
        // noofBBS: item.noofBBS,
        quantity_processed: item.quantity_processed,
        weighted_avg_of_quantity: item.weighted_avg_of_quantity,
        wastage_percentage: item.wastage_percentage,
        budgeted_wastage: item.budgeted_wastage,
        savings_per: item.savings_per,
        savings_in_ton: item.savings_in_ton,
        savings_in_lakh: item.savings_in_lakh,
        isChild: prefix === 'SBU' || prefix === 'BU' || prefix === 'Pro',
      };

      if (item.SBU) {
        mappedItem.children = getTransformProjectsData(
          item.SBU,
          'SBU',
          level + 1,
          id,
        );
      } else if (item.BU) {
        mappedItem.children = getTransformProjectsData(
          item.BU,
          'BU',
          level + 1,
          id,
        );
      } else if (item.projects) {
        mappedItem.children = getTransformProjectsData(
          item.projects,
          'Pro',
          level + 1,
          id,
        );
      } else if (item.BBS) {
        mappedItem.children = item.BBS.map((BBs, projIndex) => ({
          id: `${id}-${projIndex + 1}`,
          name: BBs.bbs_id,
          project_value: BBs.project_value || null,
          pocm: BBs.pocm,
          active_projects: BBs.active_projects,
          project_count: BBs.project_count || null,
          // noofBBS: BBs.noofBBS,
          quantity_processed: BBs.quantity_processed,
          weighted_avg_of_quantity: BBs.weighted_avg_of_quantity,
          wastage_percentage: BBs.wastage_percentage,
          budgeted_wastage: BBs.budgeted_wastage,
          savings_per: BBs.savings_per,
          savings_in_ton: BBs.savings_in_ton,
          savings_in_lakh: BBs.savings_in_lakh,
          isChild: true,
        }));
      }

      return mappedItem;
    });
  };

  const mappedData = getTransformProjectsData(dataSource, 'SBG');

  const toggleRow = (id, e) => {
    e.stopPropagation();
    setExpandedRows((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  const TableRow = ({ row, level = 0, isEven }) => {
    const isExpanded = expandedRows.has(row.id);
    const hasChildren = row.children && row.children.length > 0;

    return (
      <>
        <tr className={`bg-white relative`}>
          <td
            className={`px-3 py-4 border-b sticky left-0 ${row.isChild ? 'bg-[#7795C4] border-[#7e9bca]' : 'bg-[#1C4E9D] border-[#7e9bca] '}`}
          >
            {/* flow line */}
            {level > 0 && (
              <div
                className="absolute top-0 left-0 h-full"
                style={{
                  paddingLeft:
                    level === 1
                      ? '1rem'
                      : level === 2
                        ? '3.5rem'
                        : level === 3
                          ? '6rem'
                          : level === 4
                            ? '8rem'
                            : 0,
                }}
              >
                {/* <img alt="flowline" className="h-8 w-7" src={flowline} /> */}
              </div>
            )}

            {/* label */}
            <div className="flex items-center select-none">
              <div
                style={{ paddingLeft: `${level * 40}px` }}
                className="flex items-center text-nowrap"
              >
                {hasChildren && (
                  <div
                    className="cursor-pointer"
                    onClick={(e) => toggleRow(row.id, e)}
                  >
                    <img
                      src={isExpanded ? arrowCircleUP : arrowCircleDown}
                      alt="arrow"
                      className="w-[18px] h-[18px]"
                    />
                  </div>
                )}
                {/* {!hasChildren && <div className="w-6 mr-2" />} */}
                <span className=" select-none text-xs font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-white ml-1">
                  {row.name}
                </span>
              </div>
            </div>
          </td>

          <td className="py-4 px-3 border-b select-none text-sm font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-tertiary-placeholder">
            <span className="flex justify-center">{row.project_value}</span>
          </td>
          <td className="py-4 px-3 border-b bg-[#E8EDF5] select-none text-sm font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-tertiary-placeholder">
            <span className="flex justify-center">{row.pocm}</span>
          </td>
          {/* <td className="py-4 px-3 border-b select-none text-sm font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-tertiary-placeholder">
            <span className="flex justify-center">{row.project_count}</span>
          </td> */}
          <td className="py-4 px-3 border-b select-none text-sm font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-tertiary-placeholder">
            <span className="flex justify-center">
              {Number(row.quantity_processed).toFixed(2)}
            </span>
          </td>
          {/* <td className="py-4 px-3 border-b bg-[#E8EDF5] select-none text-sm font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-tertiary-placeholder">
            <span className="flex justify-center">
              {' '}
              {Number(row.weighted_avg_of_quantity).toFixed(2)}
            </span>
          </td> */}
          <td className="py-4 px-3 border-b select-none text-sm font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-tertiary-placeholder">
            <span className="flex justify-center">
              {Number(row.wastage_percentage).toFixed(2)}%
            </span>
          </td>
          <td className="py-4 px-3 border-b select-none text-sm font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-tertiary-placeholder">
            <span className="flex justify-center">
              {Number(row.budgeted_wastage).toFixed(2)}%
            </span>
          </td>
          <td className="py-4 px-3 border-b select-none text-sm font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-tertiary-placeholder">
            <span className="flex justify-center">
              {Number(row.savings_per).toFixed(2)}%
            </span>
          </td>
          <td className="py-4 px-3 border-b bg-[#E8EDF5] select-none text-sm font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-tertiary-placeholder">
            <span className="flex justify-center">
              {Number(row.savings_in_ton).toFixed(2)}
            </span>
          </td>
          <td className="py-4 px-3 border-b bg-[#E8EDF5] select-none text-sm font-medium font-['SF-Pro-Text-Regular, sans-serif'] text-tertiary-placeholder">
            <span className="flex justify-center">
              {Number(row.savings_in_lakh).toFixed(2)}
            </span>
          </td>
        </tr>
        {isExpanded &&
          hasChildren &&
          row.children.map((child) => (
            <TableRow key={child.id} row={child} level={level + 1} />
          ))}
      </>
    );
  };

  const renderHeader = () => {
    return COLUMNS.map((column, index) => (
      <th
        key={index}
        className={`py-2  ${column.isBtn ? 'border-b border-[#7e9bca]' : 'border-b'} place-items-center px-4 ${index === 0 ? 'w-72' : 'w-60 whitespace-nowrap'} text-sm font-['SF-Pro-Text-Regular, sans-serif'] text-primary-bg-tint text-left font-medium ${index === 0 ? 'bg-[#1C4E9D] sticky left-0' : column.colored ? 'bg-[#E8EDF5]' : ''}`}
      >
        {column.isBtn ? (
          <div className="flex !text-white items-center justify-center gap-2">
            <span className="leading-none text-xs !p-0">{column.label}</span>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center justify-center gap-2">
              <span className="leading-none text-xs !p-0">{column.label}</span>

              <Tooltip
                title={column.tooltip}
                overlayInnerStyle={{ fontSize: '10px' }}
              >
                <img
                  className="w-3.5 h-3.5 cursor-pointer"
                  src={dashboardCircle}
                  alt="Info Icon"
                />
              </Tooltip>
            </div>
            {column.subLabel && (
              <span className="font-normal text-[10px]">{column.subLabel}</span>
            )}
          </div>
        )}
      </th>
    ));
  };

  // useEffect(() => {
  //   const handleArrowScroll = (e) => {
  //     const container = document.querySelector('.scroll-container');
  //     if (!container) return;

  //     if (e.key === 'ArrowRight') {
  //       container.scrollLeft += 100;
  //     } else if (e.key === 'ArrowLeft') {
  //       container.scrollLeft -= 100;
  //     }
  //   };

  //   window.addEventListener('keydown', handleArrowScroll);
  //   return () => window.removeEventListener('keydown', handleArrowScroll);
  // }, []);

  return (
    <div className="w-full overflow-hidden rounded-[10px] mt-2">
      <ScrollContainer
        // className="scroll-container scroll-smooth"
        horizontal={mappedData.length}
        // className={`${!mappedData.length ? 'overflow-hidden' : 'overflow-auto hide-scroll'}`}
      >
        <table className="w-full bg-white table-fixed min-w-max">
          <thead>
            <tr className="">{renderHeader()}</tr>
          </thead>
          {mappedData.length ? (
            <tbody>
              {mappedData.map((row, i) => (
                <TableRow key={row.id} row={row} />
              ))}
            </tbody>
          ) : null}
        </table>

        {loading ? (
          <div className="flex items-center bg-[#F6F7F9] justify-center w-full">
            <Spin className="py-12" />
          </div>
        ) : !mappedData.length ? (
          <div className="flex items-center bg-[#F6F7F9] justify-center w-full">
            <Empty className="py-6" />
          </div>
        ) : null}
      </ScrollContainer>
    </div>
  );
}
